import { useEffect } from 'react';

import { useAmelioTranslations } from '../utils/useAmelioTranslations';
import { useError } from '../utils/useError';

import { hasRecentlyBeenRefused } from '@/api/api';

export interface UseFetchErrorsHandler {
    errors: boolean[];
}

export const useFetchErrorsHandler = ({ errors }: UseFetchErrorsHandler) => {
    const { t } = useAmelioTranslations();

    const { handleError } = useError();

    useEffect(() => {
        if (!errors.some((error) => error)) {
            return;
        }

        // These are bare booleans, so a refusal is indistinguishable
        // from a real failure here. Refusals are excluded whether or not they
        // were announced: the interceptor may have shown the specific message,
        // and where it deliberately stayed quiet for a background read (#14883),
        // replacing that silence with a vague "an error occurred" would be worse
        // than the toast this fix removed.
        if (hasRecentlyBeenRefused()) {
            return;
        }

        handleError({
            data: { title: t('errors.genericTitle'), message: t('errors.genericMessage') },
        });
    }, [errors]);
};
